<div class="d-flex">
  <input type="number"
         min="0"
         class="form-control"
         id="service-duration-hours"
         name="serviceDurationHours"
         [ngModel]="hours"
         (ngModelChange)="changeDuration($event, m.value)"
         pattern="^[0-9]*$"
         #h="ngModel"
         required />
  <label for="service-duration-minutes" class="lead col-form-label mx-2">:</label>
  <input type="number"
         min="0"
         max="59"
         class="form-control"
         id="service-duration-minutes"
         name="serviceDurationMinutes"
         [ngModel]="minutes"
         #m="ngModel"
         pattern="^[0-9]*$"
         (ngModelChange)="changeDuration(h.value, $event)"
         required />
</div>
